import { Boundaries } from "@planzone/core";
import { State } from "./types";

function handleRemoveComment(
  state: State,
  comment: Boundaries["removeComment"]["success"],
): State {
  return state.map((result) => ({
    ...result,
    discussion: {
      ...result.discussion,
      comments: result.discussion.comments.filter(
        ({ uuid }) => uuid !== comment.uuid,
      ),
    },
  }));
}

export { handleRemoveComment };
